import Env from '../base/env'
import gsap from 'gsap'


export function part1Play(tl,el)
{
  // gsap.killTweensOf(el)
  const reverseMode = el[0].parentElement.getAttribute('data-fx-reverse') * 1
  if(reverseMode) {
    el = el.reverse()
  }
  let fxSettings = {
    from:{
      y:50,
      rotateX:-90
    }
  }
  if(Env.framework.UI.VARS.smooth.direction < 1) {
    fxSettings = {
      from:{
        y:50,
        rotateX:90
      }
    }
  }
  tl.add([
    gsap.fromTo(
      el,
      {
        transformOrigin:'center 70%',
        autoAlpha:0,
        y:fxSettings.from.y,
        rotateX:fxSettings.from.rotateX
      },
      {
        autoAlpha:1,
        y:0,
        rotateX:0.01,
        stagger:.05,
        duration:1.3,
        ease:Env.eases.ride
      }
    )
  ])
}

export function part1PlayAlt(tl,el)
{
  part1Play(tl,el)
  // const reverseMode = el[0].parentElement.getAttribute('data-fx-reverse') * 1
  // if(reverseMode) {
  //   el = el.reverse()
  // }
  // tl.add([
  //   gsap.fromTo(
  //     el,
  //     {
  //       transformOrigin:'center 70%',
  //       autoAlpha:0,
  //       // filter:'blur(30px)',
  //       x:10,
  //       rotateX:90
  //     },
  //     {
  //       autoAlpha:1,
  //       // filter:'blur(0px)',
  //       x:0,
  //       rotateX:0,
  //       stagger:.05,
  //       duration:1.5,
  //       delay:.25,
  //       ease:Env.eases.ride
  //     }
  //   )
  // ])
}

export function part2Play(tl,el)
{

  let fxSettings = {
    from:{
      y:115,
      rotateX:-90
    }
  }
  if(Env.framework.UI.VARS.smooth.direction < 1) {
    fxSettings = {
      from:{
        y:-115,
        rotateX:90
      }
    }
  }
  tl.add([
    gsap.fromTo(
      el,
      {
        transformOrigin:'center 70%',
        autoAlpha:0,
        y:fxSettings.from.y,
        rotateX:fxSettings.from.rotateX
      },
      {
        autoAlpha:1,
        y:0,
        rotateX:0,
        stagger:.05,
        duration:1.3,
        ease:Env.eases.ride
      }
    )
  ])
}


export function part1Leave(tl,el,cbStart,cbComplete)
{
  gsap.killTweensOf(el)
  let fxSettings = {
    to:{
      y:-80,
      rotateX:90
    }
  }
  if(Env.framework.UI.VARS.smooth.direction < 1) {
    fxSettings = {
      to:{
        y:80,
        rotateX:-90
      }
    }
  }
  tl.add([
    gsap.fromTo(
      el,
      {
        transformOrigin:'center 50%',
      },
      {
        autoAlpha:0,
        rotateX:fxSettings.to.rotateX,
        y:fxSettings.to.y,
        duration:.6,
        stagger:.01,
        ease:Env.eases.ride,
        onComplete:()=>{
          if(typeof cbComplete != 'undefined') {
            cbComplete()
          }
        }
      }
    )
  ])
}

export function part2Leave(tl,el)
{
  let fxSettings = {
    to:{
      y:-90,
      rotateX:84
    }
  }
  if(Env.framework.UI.VARS.smooth.direction < 1) {
    fxSettings = {
      to:{
        y:90,
        rotateX:-84
      }
    }
  }
  gsap.killTweensOf(el)
  tl.add([
    gsap.fromTo(
      el,
      {
        transformOrigin:'center 50%',
      },
      {
        autoAlpha:0,
        rotateX:fxSettings.to.rotateX,
        y:fxSettings.to.y,
        stagger:.05,
        duration:1,
        ease:Env.eases.ride
      }
    )
  ])
}
